<template>
    <div>
        <banner     v-model:is-open="isOpen"
                    :auto-hide="autoHide"
                    :bg-color="bgColor"
                    :fg-color="fgColor">

            <template #banner-container>
                <div class="flex flex-col text-left">
                    <div class="flex justify-start">
                        <div class="shrink-0">
                            <slot name="icon">
                                <!-- Heroicon name: exclamation -->
                                <svg aria-hidden="true" class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path clip-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" fill-rule="evenodd" />
                                </svg>
                            </slot>
                        </div>
                        <div class="ml-3">
                            <h3     :class="fgColor"
                                    class="text-sm text-left font-semibold my-0 py-1">
                                <slot name="title">(Default) Attention needed</slot>
                            </h3>
                            <div    v-if="$slots.content"
                                    :class="fgColor"
                                    class="mt-1 text-sm">
                                <slot name="content"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </banner>
    </div>
</template>

<script>
import Banner from "@/components/Banners/Banner"

export default {
    name: "BannerWarning",
    mixins: [],
    components: { Banner },
    compatConfig: { ATTR_FALSE_VALUE: false },
    props: {
        bgColor: {
            type: String,
            default: 'bg-yellow-50',
        },
        fgColor: {
            type: String,
            default: 'text-yellow-700',
        },
        isOpen: {
            type: Boolean,
            default: true,
        },
        autoHide: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {}
    },
    mounted() {

    },
    methods: {},
    watch: {},
    computed: {},
}
</script>
